<template>
  <div class="warp">
    <div class="top">
      <data-type
        ref="search"
        @getData="bindgetSearchElem"
        :timeType="timeType"
        :showExporyytn="false"
        :timeInterval="toTime"
        :alarnclass="alarnclass"
      >
      </data-type>
    </div>
    <div class="bottom">
      <el-table
        :data="tableData"
        height="100%"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          prop="measureName"
          label="计量点名称"
        ></el-table-column>
        <el-table-column
          prop="displayValue"
          label="本期电量"
          align="right"
          sortable
          width="180"
        ></el-table-column>
        <el-table-column
          prop="loss"
          label="损耗电量"
          align="right"
          sortable
          width="180"
        ></el-table-column>
        <el-table-column
          prop="scale"
          label="损耗比例"
          align="right"
          sortable
          width="180"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import DataType from "@/components/common/datatype";
import * as utils from "@/utils/index.js";
import tree from "@/utils/tree.js";
export default {
  components: { DataType },
  data() {
    return {
      timeType: [
        { value: "0", label: "日" },
        { value: "2", label: "月" },
        { value: "5", label: "年" },
      ],
      toTime: "toTime",
      alarnclass: "alarnclass",
      tableData: [],
      viewId: "",
      measure: [],
      dataType: "100229",
      datasType: [
        { pointCode: "100229", name: "电" },
        { pointCode: "100401", name: "水" },
        { pointCode: "100701", name: "气" },
      ],
      viewsData: [],
    };
  },
  created() {
    let vm = this;
    vm.getViewId();
  },
  methods: {
    getViewId() {
      let vm = this;
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          vm.$store.state.user.currentCompanyId,
          "/nlt/shfx1",
          null
        )
        .then((res) => {
          if (res) {
            vm.viewId = utils.findDataByParam("viewId", false, res.data);
            vm.viewsData = [];
            res.data.forEach((item) => {
              if (item.param == "measures") {
                vm.viewsData = JSON.parse(item.value);
              }
            });
            if (vm.viewId) {
              vm.$api.view.getViewTreeNodes(vm.viewId).then((res) => {
                if (!res) {
                  return;
                }
                vm.measure = res.data;
                vm.getData();
              });
            }
          }
        });
    },
    bindgetSearchElem() {
      this.getData();
    },
    getData() {
      let vm = this;
      let params = [];
      let elem = vm.$refs.search.getElem();
      let requestUrl = "";
      if (elem.dateType === "0") {
        requestUrl = this.$api.quantity.getQuantityDay5;
      } else if (elem.dateType === "2") {
        requestUrl = this.$api.quantity.getQuantityMonth2;
      } else {
        requestUrl = this.$api.quantity.getQuantityYear2;
      }
      for (let i = 0; i < vm.measure.length; i++) {
        params.push({
          measureId: vm.measure[i].measureId,
          pointNumber: vm.viewsData.pointNumber,
          pointCode: vm.viewsData.pointCode,
        });
      }
      requestUrl(JSON.stringify(params), elem.fromDate, elem.toDate).then(
        (res) => {
          for (let i = 0; i < vm.measure.length; i++) {
            vm.measure[i].value = "";
            const item = res.data.find(
              (obj) => obj.measureId == vm.measure[i].measureId
            );
            if (item) {
              vm.measure[i].value = item.data[0]?.value;
            }
          }
          vm.tableData = tree.dataToTreeDataForCalcEle(vm.measure, "0");
        }
      );
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #dbdbdb;color: #666;";
      }
    },
  },
};
</script>

<style scoped>
.warp {
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  height: 100%;
}
.bottom {
  flex: 1;
  overflow: auto;
  margin-top: 14px;
}
</style>
